import { useEffect, useMemo, useRef, useState } from "react";
import { addData, deleteFileByUrl, getDocOnCondition, handleFireBaseUpload } from "../Firebase/firestore";
import { getData } from "../Firebase/firestore";
import { db } from "../firebase";
import './main.css'
import sh from '../assets/search.png'

const Clothes = {
  "Coat": [ "Suits", "blazer", "kurta" ] ,
  "Pant" : [ "Suits", "formal" ], 
  "Shirt" : [ "Suits", "formal" ], 
  "Vest" : [ "Suits" ],
  "Pajama" : ["kurta"],
  "Sadri" : ["kurta"],
  "Kurta" : ["kurta"]
}

const suits = ['Coat', 'Vest', 'Shirt', 'Pant', "Pajama", "Sadri", "Kurta"]

function Suits() {
    const [fabric, setFabric] = useState()
    const [useFabric, setUseFabric] = useState([])

    const [suitImg, setSuitImg] = useState()
    const [styles, setStyles] = useState()
    
    const [selFab, setSelFab] = useState()
    const [status, updateStatus] = useState()
    const [state, updateState] = useState(0)
    const [total, updateTotal] = useState(1)
    const [progress, setProgress] = useState(0)
    const [successModal, setSuccessModal] = useState(null)
    const [deletingUpload, setDeletingUpload] = useState(false)

    const price= useRef()
    
    
    const [sel_type, setSelType] = useState("Coat")
    const isSadri = sel_type === "Sadri"

    const [cloth_type, setClothType] = useState()
    
    const [button_modal, setButtonModal] = useState(false)
    const [Buttons, setButtons] = useState([])
    const [recomButtons, setRecomButtons] = useState([])
    const [defaultRecomButtonId, setDefaultRecomButtonId] = useState(null)
    const [recomSearch, setRecomSearch] = useState("")
    const [recomMaterialFilter, setRecomMaterialFilter] = useState("all")
    const BUTTON_MATERIAL_FILTERS = ["all", "metal", "plastic", "wood", "fabric", "ring"]
    const [brand, setBrands] = useState([])
    const [widthOptions, setWidthOptions] = useState([])
    const [brandFilter, setBrandFilter] = useState("")
    const [widthFilter, setWidthFilter] = useState("")
    const [search, setSearch] = useState("")
    const [brandDropdownOpen, setBrandDropdownOpen] = useState(false)
    const [widthDropdownOpen, setWidthDropdownOpen] = useState(false)
    const [typeDropdownOpen, setTypeDropdownOpen] = useState(false)
    const [clothDropdownOpen, setClothDropdownOpen] = useState(false)
    const brandDropdownRef = useRef(null)
    const widthDropdownRef = useRef(null)
    const typeDropdownRef = useRef(null)
    const clothDropdownRef = useRef(null)

    useEffect(()=>{
      const fetchButtons = async() => {
          const buttonsCollection = db.collection('Buttons');
          const buttonsData = await getData(buttonsCollection);
          setButtons(buttonsData);
      };
      fetchButtons();
  }, [])

    useEffect(()=>{
      if(sel_type){
        setClothType( Clothes[sel_type][0] )
      }
    }, [sel_type])

    useEffect(() => {
      if (isSadri) {
        setStyles(null)
      }
    }, [isSadri])

    const autoRecomButtonIdRef = useRef(null)
    useEffect(() => {
      if (!Buttons || Buttons.length === 0) return
      const prevAutoId = autoRecomButtonIdRef.current

      if (!selFab) {
        if (prevAutoId) {
          setRecomButtons((prev) => prev.filter((b) => b.id !== prevAutoId))
          autoRecomButtonIdRef.current = null
        }
        return
      }

      const fabricKey = String(selFab.name || selFab.id || "").toLowerCase()
      const matches = Buttons.filter((b) => {
        const isTargetMatch = !sel_type || (b.targetType || "").toLowerCase() === sel_type.toLowerCase()
        const isFabricMatch = b.fabricId && String(b.fabricId).toLowerCase() === fabricKey
        return isTargetMatch && isFabricMatch
      })
      const match = matches[0] || null

      setRecomButtons((prev) => {
        let next = prev
        if (prevAutoId && prevAutoId !== match?.id) {
          next = next.filter((b) => b.id !== prevAutoId)
        }
        if (match && !next.find((b) => b.id === match.id)) {
          if (next.length >= 5) {
            next = [match, ...next.slice(0, 4)]
          } else {
            next = [match, ...next]
          }
        }
        return next
      })
      autoRecomButtonIdRef.current = match ? match.id : null
    }, [selFab, Buttons, sel_type])

    useEffect(()=>{
        const collection=  db.collection('Fabric').doc('Suits').collection('fabrics')
        getData(collection).then((data)=>{
            setFabric(data)
            setUseFabric(data)
            const brands = []
            const widths = []
            data.forEach((val) => {
              if (val.brand && !brands.includes(val.brand)) {
                brands.push(val.brand)
              }
              if (val.width && !widths.includes(val.width)) {
                widths.push(val.width)
              }
            })
            setBrands(brands)
            setWidthOptions(widths)
            console.log(data)
        })
    }, [])

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (brandDropdownRef.current && !brandDropdownRef.current.contains(event.target)) {
          setBrandDropdownOpen(false)
        }
        if (widthDropdownRef.current && !widthDropdownRef.current.contains(event.target)) {
          setWidthDropdownOpen(false)
        }
        if (typeDropdownRef.current && !typeDropdownRef.current.contains(event.target)) {
          setTypeDropdownOpen(false)
        }
        if (clothDropdownRef.current && !clothDropdownRef.current.contains(event.target)) {
          setClothDropdownOpen(false)
        }
      }
      document.addEventListener("mousedown", handleClickOutside)
      return () => document.removeEventListener("mousedown", handleClickOutside)
    }, [])

    useEffect(() => {
      if (!fabric) {
        return
      }
      let filtered = [...fabric]

      if (search) {
        const terms = String(search).toLowerCase().split(" ").filter(Boolean)
        filtered = filtered.filter((val) => terms.every((term) => JSON.stringify(val).toLowerCase().includes(term)))
      }

      if (brandFilter) {
        filtered = filtered.filter((val) => (val.brand || "").toLowerCase() === brandFilter.toLowerCase())
      }

      if (widthFilter) {
        filtered = filtered.filter((val) => (val.width || "").toLowerCase() === widthFilter.toLowerCase())
      }

      setUseFabric(filtered)
    }, [fabric, search, brandFilter, widthFilter])


    const returnStyle = (name)=> {
      return name.split(".")[0]
    }

    const Upload = async()=>{
      try{

        if(suitImg && (isSadri || styles)){

          console.log(cloth_type, sel_type)
          updateState(0)
          updateTotal((suitImg?.length || 0) + (isSadri ? 0 : (styles?.length || 0)))
          setProgress(1)
          
          // cloth_type
          // sel_type
          let ref = `${cloth_type}/${sel_type}`

          updateStatus("Uploading Display Images...")
          const data = await uploadMultipleFiles(suitImg, ref)

          let data1 = {}
          if (!isSadri) {
            ref = `Fabrics/${cloth_type}/${sel_type}/Styles`
            updateStatus("Uploading Style Images...")
            data1 = await uploadMultipleFiles(styles, ref)
          }
          
          setProgress(0)

          updateStatus("Upload Success. Updaing Database...")

          const ID = sel_type + "-" + (new Date().getTime()).toString()
          
          const styleRef = db.collection("Fabric").doc(cloth_type).collection(`${sel_type}_style`).doc(ID)

          const Data = {
              "fabricID":selFab["id"],
              "fabric" : selFab["name"],
              "fabricImg" : selFab["src"],
              "price" : price.current.value,
              "brand" : selFab["brand"],
              "brandImg" : selFab["brandImg"],
              "src":data[Object.keys(data)[0]],
              "single": isSadri ? [] : [data1[Object.keys(data1)[0]]],
              "id":  ID,
              "style" : styleRef,
              "recommended_buttons": rankedRecomButtons.map((e)=>(e.id)),
              ...(rankedRecomButtons.length && defaultRecomButtonId
                ? { default_recommended_button: defaultRecomButtonId }
                : {}),
            }
          console.log("1: ", Data)

          const collection = db.collection("Fabric").doc(cloth_type).collection(sel_type)
          await addData(collection, null, Data)
          
          console.log("2: ", data, "3. ", data1)
          
          var batch = db.batch()
          Object.keys(data).forEach((doc1) => {
            var docRef = styleRef.collection("display").doc(doc1);
            batch.set(docRef, {"src":data[doc1]});
          });
          await batch.commit()

          if (!isSadri) {
            var batch = db.batch()
            Object.keys(data1).forEach((doc1) => {
              var docRef = styleRef.collection("style").doc(doc1);
              batch.set(docRef, {"src":data1[doc1]});
            });
            await batch.commit()
          }

          // await styleRef.set({
          //   "style":data1,
          //   "display":data
          // })
        
          updateStatus("Uploaded Successfully")
          const defaultBtn = recomButtons.find((b) => b.id === defaultRecomButtonId)
          setSuccessModal({
            id: ID,
            outfitItem: sel_type,
            outfitType: cloth_type,
            fabric: selFab?.name,
            brand: selFab?.brand,
            price: price.current?.value,
            displayCount: suitImg?.length || 0,
            styleCount: isSadri ? 0 : (styles?.length || 0),
            recommendedButtons: recomButtons.length,
            defaultButtonLabel: defaultBtn?.name || (defaultRecomButtonId ? String(defaultRecomButtonId) : null),
            displayUrls: Object.values(data),
            styleUrls: Object.values(data1),
          })
          setProgress(0)

        }else{
          console.log("upload images")
        }

      }catch(e){
        console.log("from uploading", e)
        updateStatus("Upload failed. Please try again.")
        setProgress(0)
      }
    }

    const deleteUploadedOutfit = async () => {
      if (!successModal) {
        return
      }
      try {
        setDeletingUpload(true)
        const urlsToDelete = [...new Set([...(successModal.displayUrls || []), ...(successModal.styleUrls || [])])]
        await Promise.all(urlsToDelete.map((url) => deleteFileByUrl(url)))

        const collection = db.collection("Fabric").doc(successModal.outfitType).collection(successModal.outfitItem)
        const docIds = await getDocOnCondition(collection, "id", successModal.id)
        if (docIds && docIds.length > 0) {
          await collection.doc(docIds[0]).delete()
        }

        const styleRef = db.collection("Fabric").doc(successModal.outfitType).collection(`${successModal.outfitItem}_style`).doc(successModal.id)
        const displayDocs = await getData(styleRef.collection("display"))
        const styleDocs = await getData(styleRef.collection("style"))

        await Promise.all((displayDocs || []).map((item) => styleRef.collection("display").doc(item.doc).delete()))
        await Promise.all((styleDocs || []).map((item) => styleRef.collection("style").doc(item.doc).delete()))
        await styleRef.delete()

        updateStatus("Uploaded outfit deleted successfully.")
        setSuccessModal(null)
      } catch (error) {
        console.log("delete uploaded outfit", error)
        updateStatus("Unable to delete uploaded outfit.")
      } finally {
        setDeletingUpload(false)
      }
    }
    const uploadMultipleFiles = async(arr, ref)=>{
      let data = {}
      
      for(let i=0;i<arr.length;i++){
          const name = returnStyle(arr[i].name)
          data[name] = await handleFireBaseUpload(name+"-"+(new Date().getTime()).toString(), arr[i], ref)
          updateState((state)=>(state+1))
      }
      
      return data
  }

  useEffect(()=>{
    console.log("Recommended buttons changed", recomButtons, recomButtons.map((e)=>(e.id)) );
  }, [recomButtons])
  const MAX_RECOM_BUTTONS = 5

  const checkButton = (e, event)=>{
      if(e.target.checked){
        if(!recomButtons.find((val)=>(val.id === event.id))){
          if(recomButtons.length >= MAX_RECOM_BUTTONS){
            alert(`You can only select up to ${MAX_RECOM_BUTTONS} recommended buttons. Deselect one to add another.`)
            return
          }
          setRecomButtons((prev)=>([...prev, event]))
        }
      } else {
        if(recomButtons.find((val)=>(val.id === event.id))){
          setRecomButtons((prev)=>( prev.filter((val)=>(val.id !== event.id)) ))
        }
      }
    }

  const getRankedRecomButtons = ()=>{
    if(!recomButtons || recomButtons.length === 0) return []
    const fabricKey = selFab ? (selFab.name || selFab.id) : null
    const sameFabric = fabricKey ? recomButtons.find((b)=> b.fabricId && String(b.fabricId).toLowerCase() === String(fabricKey).toLowerCase()) : null
    const rest = sameFabric ? recomButtons.filter((b)=> b.id !== sameFabric.id) : [...recomButtons]
    return sameFabric ? [sameFabric, ...rest] : rest
  }

  const rankedRecomButtons = getRankedRecomButtons()

  const defaultRecomSyncKey = useMemo(
    () =>
      `${recomButtons.map((b) => b.id).join(",")}|${selFab?.id || ""}|${String(selFab?.name || "")}`,
    [recomButtons, selFab]
  )

  useEffect(() => {
    if (!recomButtons.length) {
      setDefaultRecomButtonId(null)
      return
    }
    const ranked = getRankedRecomButtons()
    setDefaultRecomButtonId((prev) => {
      if (prev && ranked.some((b) => b.id === prev)) return prev
      return ranked[0] ? ranked[0].id : null
    })
  }, [defaultRecomSyncKey])
  const getRankOfButton = (id)=>{
    const idx = rankedRecomButtons.findIndex((b)=> b.id === id)
    return idx === -1 ? null : idx + 1
  }


    return ( 
    <div className="outfit-page">
    <div className="Suits outfit-form-panel fabric-modern">
    <h4 className="outfit-form-title">Uploading Display Images</h4>
        <div className="f-inputs outfit-form-field" ref={typeDropdownRef}>
          <b>Outfit Item</b>
          <div className="fabric-custom-select">
            <button type="button" className="fabric-custom-select-trigger outfit-form-select-trigger" onClick={() => setTypeDropdownOpen((v) => !v)}>
              <span>{sel_type}</span>
              <span className={`fabric-custom-select-arrow ${typeDropdownOpen ? "open" : ""}`}>▾</span>
            </button>
            {typeDropdownOpen && (
              <div className="fabric-custom-select-menu outfit-form-select-menu">
                {Object.keys(Clothes).map((val) => (
                  <button
                    type="button"
                    key={val}
                    className={`fabric-custom-select-option ${sel_type === val ? "active" : ""}`}
                    onClick={() => {
                      setSelType(val)
                      setTypeDropdownOpen(false)
                    }}
                  >
                    {val}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>

        {sel_type && 
          <div className="f-inputs outfit-form-field" ref={clothDropdownRef}>
            <b>Outfit Type</b>
            <div className="fabric-custom-select">
              <button type="button" className="fabric-custom-select-trigger outfit-form-select-trigger" onClick={() => setClothDropdownOpen((v) => !v)}>
                <span>{cloth_type || "Select outfit type"}</span>
                <span className={`fabric-custom-select-arrow ${clothDropdownOpen ? "open" : ""}`}>▾</span>
              </button>
              {clothDropdownOpen && (
                <div className="fabric-custom-select-menu outfit-form-select-menu">
                  {Clothes[sel_type].map((val) => (
                    <button
                      type="button"
                      key={val}
                      className={`fabric-custom-select-option ${cloth_type === val ? "active" : ""}`}
                      onClick={() => {
                        setClothType(val)
                        setClothDropdownOpen(false)
                      }}
                    >
                      {val}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>}
        

        <div className="f-inputs">
          <b>Price</b>
          <input placeholder="price" ref = {price}/>
        </div>

        <div className="f-inputs">
          <div className="fabric-file-title"><b>Upload Display Images</b></div>
          <input className="fabric-file-input" placeholder="" type="file" onChange={(e)=>{setSuitImg(e.target.files)}} multiple/>
          {suitImg && <div className="outfit-file-count"><b>{suitImg.length} Files Selected</b></div>}
        </div>
        
        <div className={`f-inputs outfit-inline-fabric-select ${selFab ? "outfit-inline-fabric-select-active" : ""}`}>
          {!selFab && <div className="outfit-inline-fabric-label">Select any fabric</div>}
          {selFab ? (
            <div className="outfit-inline-fabric-value">
              <img src={selFab.src} alt={selFab.name} />
              <div className="outfit-inline-fabric-copy">
                <strong>{selFab.name}</strong>
                <span>{selFab.brand} | {selFab.color}</span>
                <small>Selected from fabric list</small>
              </div>
              <button type="button" className="outfit-inline-fabric-remove" onClick={() => setSelFab(null)}>
                Remove
              </button>
            </div>
          ) : (
            <div className="outfit-inline-fabric-placeholder">Choose from the fabric list on the right</div>
          )}
        </div>

    
    
        <h4 className="outfit-section-title">Uploading Style Images</h4>
        

        <div className="f-inputs">
          <div className="fabric-file-title"><b>Upload Style Images</b></div>
          <input
            id="folder"
            className="fabric-file-input"
            type="file"
            onChange={(e)=>{setStyles(e.target.files)}}
            multiple
            disabled={isSadri}
          />
          {isSadri ? (
            <div className="outfit-file-count"><b>There is no need for style images for the Sadri</b></div>
          ) : (
            styles && <div className="outfit-file-count"><b>{styles.length} Files Selected</b></div>
          )}
        </div>

        <div className="f-inputs">
          <b>Recommended Buttons</b>
          <button type="button" className="fabric-submit-btn outfit-secondary-btn" onClick={()=>{setButtonModal(true)}} >
            Select Recommended Buttons
            {recomButtons.length > 0 && (
              <span className="recom-btn-count-badge">{recomButtons.length}</span>
            )}
          </button>
        </div>
        { button_modal && (
          <div className="recom-modal-backdrop" onClick={()=>{setButtonModal(false);}}>
            <div className="recom-modal" onClick={(ev)=> ev.stopPropagation()}>
              <div className="recom-modal-header">
                <div>
                  <h3>Select Recommended Buttons</h3>
                  <p>Showing buttons for <b>{sel_type}</b>. Select up to {MAX_RECOM_BUTTONS}. Button matching fabric <b>{selFab?.name || "—"}</b> will be ranked #1 automatically.</p>
                </div>
                <button type="button" className="recom-modal-close" onClick={()=>{setButtonModal(false);}} aria-label="Close">
                  ×
                </button>
              </div>

              <div className="recom-modal-filterbar">
                <div className="recom-modal-chips">
                  {BUTTON_MATERIAL_FILTERS.map((mat)=> (
                    <button
                      key={mat}
                      type="button"
                      className={`recom-modal-chip ${recomMaterialFilter === mat ? "active" : ""}`}
                      onClick={()=> setRecomMaterialFilter(mat)}
                    >
                      {mat}
                    </button>
                  ))}
                </div>
                <div className="recom-modal-search">
                  <input
                    type="text"
                    placeholder="Search button by name"
                    value={recomSearch}
                    onChange={(ev)=> setRecomSearch(ev.target.value)}
                  />
                  <img src={sh} alt="Search" />
                </div>
              </div>

              <div className="recom-modal-body">
                {(() => {
                  const filtered = Buttons.filter((b) => {
                    if ((b.targetType || "").toLowerCase() !== (sel_type || "").toLowerCase()) return false;
                    if (recomMaterialFilter !== "all" && (b.material || "").toLowerCase() !== recomMaterialFilter) return false;
                    if (recomSearch && !JSON.stringify(b).toLowerCase().includes(recomSearch.toLowerCase())) return false;
                    return true;
                  });
                  if (filtered.length === 0) {
                    return (
                      <div className="recom-modal-empty">
                        No buttons found for <b>{sel_type}</b>{recomMaterialFilter !== "all" ? ` in ${recomMaterialFilter}` : ""}{recomSearch ? ` matching "${recomSearch}"` : ""}.
                      </div>
                    );
                  }
                  return (
                    <div className="recom-modal-grid">
                      {filtered.map((e, i)=> {
                        const isSelected = !!recomButtons.find((val)=>(val.id === e.id))
                      return (
                        <div
                          className={`recom-button-card ${isSelected ? "selected" : ""}`}
                          key={e.id || i}
                          onClick={()=> checkButton({ target: { checked: !isSelected } }, e)}
                        >
                          <div className="recom-button-card-image-wrap">
                            <img src={e.src} alt={e.name || "Button"} className="recom-button-card-image" />
                            {isSelected && (
                              <span className="recom-button-card-check" aria-hidden>
                                #{getRankOfButton(e.id)}
                              </span>
                            )}
                          </div>
                          <div className="recom-button-card-details">
                            <div className="recom-button-card-name" title={e.name || "-"}>{e.name || "Untitled"}</div>
                            <div className="recom-button-card-specs">
                              <div className="recom-button-spec-row">
                                <span className="recom-button-spec-label">Material</span>
                                <span className="recom-button-spec-value">{e.material || "-"}</span>
                              </div>
                              <div className="recom-button-spec-row">
                                <span className="recom-button-spec-label">Target</span>
                                <span className="recom-button-spec-value">{e.targetType || "-"}</span>
                              </div>
                              <div className="recom-button-spec-row">
                                <span className="recom-button-spec-label">Style</span>
                                <span className="recom-button-spec-value">{e.style || "-"}</span>
                              </div>
                              {e.color && (
                                <div className="recom-button-spec-row">
                                  <span className="recom-button-spec-label">Color</span>
                                  <span className="recom-button-spec-value recom-button-spec-color">
                                    <span className="recom-button-color-dot" style={{ background: e.color }}></span>
                                    <span className="recom-button-color-hex">{e.color}</span>
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                          {isSelected && (
                            <div className="recom-button-card-actions">
                              {defaultRecomButtonId === e.id ? (
                                <span className="recom-default-pill">Default for outfit</span>
                              ) : (
                                <button
                                  type="button"
                                  className="recom-use-default-btn"
                                  onClick={(ev) => {
                                    ev.stopPropagation()
                                    setDefaultRecomButtonId(e.id)
                                  }}
                                >
                                  Use as default
                                </button>
                              )}
                            </div>
                          )}
                        </div>
                      )
                    })}
                    </div>
                  );
                })()}
              </div>

              <div className="recom-modal-footer">
                <span className="recom-modal-summary">{recomButtons.length} / {MAX_RECOM_BUTTONS} selected · default: {defaultRecomButtonId ? (recomButtons.find((b) => b.id === defaultRecomButtonId)?.name || "—") : "—"}</span>
                <div className="recom-modal-actions">
                  <button type="button" className="fabric-submit-btn recom-modal-clear" onClick={()=> setRecomButtons([])} disabled={recomButtons.length === 0}>
                    Clear
                  </button>
                  <button type="button" className="fabric-submit-btn recom-modal-done" onClick={()=>{setButtonModal(false);}}>
                    Done
                  </button>
                </div>
              </div>
            </div>
          </div>

        )}
        {progress === 1 ? (
          <div className="outfit-upload-progress">
            <div className="outfit-upload-progress-top">
              <span>{status || "Uploading..."}</span>
              <strong>{Math.floor((state / total) * 100)}%</strong>
            </div>
            <div className="outfit-upload-progress-track">
              <div
                className="outfit-upload-progress-fill"
                style={{ width: `${(state / total) * 100}%` }}
              />
            </div>
            <div className="outfit-upload-progress-meta">
              {state} / {total} files uploaded
            </div>
          </div>
        ) : (
          <button
          className="fabric-submit-btn"
          disabled = {!cloth_type || !sel_type || !selFab || !suitImg || (!isSadri && !styles) || !price.current?.value}
          onClick={async()=>{
            
              await Upload()
            
            
          }}
          >Upload</button>
        )}

    {rankedRecomButtons.length > 0 && (
      <div className="recom-ranked-preview">
        <div className="recom-ranked-preview-header">
          <b>Recommended Buttons</b>
          <span>{rankedRecomButtons.length} / {MAX_RECOM_BUTTONS} · Ranked order</span>
        </div>
        <p className="recom-ranked-preview-hint">Pick one row and use <strong>Use as default</strong> so the storefront pre-selects that button.</p>
        <div className="recom-ranked-preview-list">
          {rankedRecomButtons.map((b, idx)=>{
            const rank = idx + 1
            const isAutoRanked = rank === 1 && selFab && b.fabricId && String(b.fabricId).toLowerCase() === String(selFab.name || selFab.id).toLowerCase()
            const isDefault = defaultRecomButtonId === b.id
            return (
              <div key={b.id} className={`recom-ranked-preview-item ${isDefault ? "is-default" : ""}`}>
                <span className={`recom-ranked-badge ${isAutoRanked ? "auto" : ""}`}>#{rank}</span>
                <img src={b.src} alt={b.name || "Button"} />
                <div className="recom-ranked-preview-info">
                  <span className="recom-ranked-preview-name" title={b.name || "-"}>{b.name || "Untitled"}</span>
                  <span className="recom-ranked-preview-meta">{b.material || "-"}{isAutoRanked ? " · matches fabric" : ""}{isDefault ? " · default" : ""}</span>
                </div>
                {isDefault ? (
                  <span className="recom-ranked-default-pill">Default</span>
                ) : (
                  <button
                    type="button"
                    className="recom-ranked-set-default"
                    onClick={() => setDefaultRecomButtonId(b.id)}
                  >
                    Use as default
                  </button>
                )}
                <button
                  type="button"
                  className="recom-ranked-remove"
                  onClick={()=> setRecomButtons((prev)=> prev.filter((p)=> p.id !== b.id))}
                  aria-label="Remove"
                >
                  ×
                </button>
              </div>
            )
          })}
        </div>
      </div>
    )}

    {status && <div style={{"color":"red"}}>{status}</div>}

    </div> 
    <div className="outfit-side-panel">
      <div className="outfit-side-header">
        <div>
          <h4>Fabric List</h4>
          <p>Select fabric for this outfit upload</p>
        </div>
      </div>

      <div className="outfit-fabric-filterbar">
        <div className="outfit-fabric-filter-item" ref={brandDropdownRef}>
          <div className="fabric-custom-select">
            <button type="button" className="fabric-custom-select-trigger edit-fabric-select-trigger" onClick={() => setBrandDropdownOpen((v) => !v)}>
              <span>{brandFilter || "All Brands"}</span>
              <span className={`fabric-custom-select-arrow ${brandDropdownOpen ? "open" : ""}`}>▾</span>
            </button>
            {brandDropdownOpen && (
              <div className="fabric-custom-select-menu outfit-fabric-select-menu">
                <button type="button" className={`fabric-custom-select-option ${brandFilter === "" ? "active" : ""}`} onClick={() => { setBrandFilter(""); setBrandDropdownOpen(false); }}>All Brands</button>
                {brand.map((val) => (
                  <button type="button" key={val} className={`fabric-custom-select-option ${brandFilter === val ? "active" : ""}`} onClick={() => { setBrandFilter(val); setBrandDropdownOpen(false); }}>{val}</button>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="outfit-fabric-filter-item" ref={widthDropdownRef}>
          <div className="fabric-custom-select">
            <button type="button" className="fabric-custom-select-trigger edit-fabric-select-trigger" onClick={() => setWidthDropdownOpen((v) => !v)}>
              <span>{widthFilter || "All Widths"}</span>
              <span className={`fabric-custom-select-arrow ${widthDropdownOpen ? "open" : ""}`}>▾</span>
            </button>
            {widthDropdownOpen && (
              <div className="fabric-custom-select-menu outfit-fabric-select-menu">
                <button type="button" className={`fabric-custom-select-option ${widthFilter === "" ? "active" : ""}`} onClick={() => { setWidthFilter(""); setWidthDropdownOpen(false); }}>All Widths</button>
                {widthOptions.map((val) => (
                  <button type="button" key={val} className={`fabric-custom-select-option ${widthFilter === val ? "active" : ""}`} onClick={() => { setWidthFilter(val); setWidthDropdownOpen(false); }}>{val}</button>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="outfit-fabric-search">
          <div className="edit-fabric-search-box outfit-fabric-search-box">
            <input
              className="search_fabric_clothes"
              placeholder="Search fabric"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <img src={sh} alt="Search" />
          </div>
        </div>
      </div>

      <div className="outfit-fabric-list">
        {useFabric && useFabric.length > 0 ? (
          useFabric.map((val) => (
            <button
              key={val.id}
              type="button"
              className={`outfit-fabric-card ${selFab?.id === val.id ? "outfit-fabric-card-active" : ""}`}
              onClick={() => setSelFab(val)}
            >
              <img src={val["src"]} alt={val.name} className="outfit-fabric-card-image" />
              <div className="outfit-fabric-card-info">
                <h5>{val.name}</h5>
                <p>{val.brand}</p>
                <span>{val.color}</span>
              </div>
            </button>
          ))
        ) : (
          <div className="outfit-empty-state">No fabrics found.</div>
        )}
      </div>
    </div>
    {successModal && (
      <div className="outfit-success-modal-backdrop">
        <div className="outfit-success-modal">
          <div className="outfit-success-modal-badge">Upload Successful</div>
          <h3>Outfit uploaded successfully</h3>
          <div className="outfit-success-modal-grid">
            <div><span>ID</span><strong>{successModal.id}</strong></div>
            <div><span>Item</span><strong>{successModal.outfitItem}</strong></div>
            <div><span>Type</span><strong>{successModal.outfitType}</strong></div>
            <div><span>Fabric</span><strong>{successModal.fabric}</strong></div>
            <div><span>Brand</span><strong>{successModal.brand}</strong></div>
            <div><span>Price</span><strong>{successModal.price}</strong></div>
            <div><span>Display Images</span><strong>{successModal.displayCount}</strong></div>
            <div><span>Style Images</span><strong>{successModal.styleCount}</strong></div>
            <div><span>Recommended Buttons</span><strong>{successModal.recommendedButtons}</strong></div>
            <div><span>Default Button</span><strong>{successModal.defaultButtonLabel || "—"}</strong></div>
          </div>
          <button type="button" className="fabric-submit-btn outfit-success-close" onClick={() => setSuccessModal(null)}>
            Close
          </button>
          <button
            type="button"
            className="fabric-submit-btn outfit-delete-close"
            onClick={() => {
              if (deletingUpload) return;
              if (window.confirm(`Are you sure you want to delete ${successModal?.outfitItem || 'this uploaded outfit'}? This action cannot be undone.`)) {
                deleteUploadedOutfit();
              }
            }}
            disabled={deletingUpload}
          >
            {deletingUpload ? "Deleting..." : "Delete This Upload"}
          </button>
        </div>
      </div>
    )}
    </div>    
    );
}

export default Suits;